export const serviceSso = 'https://sso.mm-api.agency/';
// export const serviceSso = 'https://onboarding.mm-dev.agency/';
export const serviceToken = serviceSso+'oauth/token';
export const authCaptureTransaction = "https://apitest.authorize.net/xml/v1/request.api";   